<ion-header mode="ios">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="closePage()">
        <ion-icon [src]="'/assets/icons/' + capacitor.scheme + '/x.svg'"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>{{ capacitor.translateString('Privacy') }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding www">
  <ion-grid>
    <h1>{{ capacitor.translateString('Privacy') }}</h1>
    <p><strong>Last update: 8 April 2025</strong></p>

    <p>
      This privacy policy has been compiled to better serve those who are concerned with how their
      personal information is being used online. Please read our privacy policy carefully to get a
      clear understanding of how iBucket (“iBucket,” “we,” “us,” or “our”) collect, use, protect or
      otherwise handle your Personally Identifiable Information in accordance with our website and
      apps.
    </p>

    <div class="highlight">
      <h3 class="wp-block-heading">Privacy Highlights</h3>

      <p><b>Privacy is important to us, as well for our users. Here’s why:</b></p>

      <ul class="wp-block-list">
        <li>We store your data on servers the Netherlands (EU)</li>
        <li>We provide to ability to set your profile to private</li>
        <li>We don’t store any passwords or payments</li>
        <li>We don’t sell your data to third-parties</li>
        <li>We secure your data via SSL and encryption</li>
        <li>We allow you to delete your account at any time</li>
        <li>We don’t collect or store any location data</li>
        <li>We don’t collect user-based analytics data</li>
        <li>We run completely on green energy</li>
      </ul>
    </div>

    <h3 class="wp-block-heading">Information we Collect</h3>

    <p>
      We collect several different types of information for various purposes to provide and improve
      our Service to you.
    </p>

    <p>
      <strong>Data Linked to You</strong><br />While creating an account at our Service, we
      optionally ask you to provide us with certain personally identifiable information that can be
      used to contact or identify you (“Personal Data”). Please read section 5 on how to change your
      account and privacy settings. The following data, which may be collected and linked to your
      identity, may be used of the following purposes:
    </p>

    <p><em>App Functionality</em></p>

    <ul class="wp-block-list">
      <li>Purchases (In-App-Purchase History)</li>

      <li>Contact Info (Email Address, Name)</li>

      <li>User Content (Content, Photos, Customer Support)</li>

      <li>Identifiers (User ID)</li>
    </ul>

    <p>
      <strong>Data Not Linked to You</strong><br />We may also collect information that your browser
      sends whenever you visit our Service or when you access the Service by or through a mobile
      device (“Usage Data”). This Usage Data may include information such as your computer’s
      Internet Protocol address (e.g. IP address), device type and app version. The following data,
      which may be collected but is not linked to your identity, may be used of the following
      purposes:
    </p>

    <p><em>Analytics</em></p>

    <ul class="wp-block-list">
      <li>Usage Data (Product Interaction, Other Usage Data)</li>

      <li>Diagnostics (Crash Data, Performance Data)</li>
    </ul>

    <p><em>App Functionality</em></p>

    <ul class="wp-block-list">
      <li>Usage Data (Product Interaction, Other Usage Data)</li>

      <li>Diagnostics (Crash Data, Performance Data)</li>
    </ul>

    <p>
      <strong>Tracking &amp; Cookies Data</strong><br />We use cookies and similar tracking
      technologies to track the activity on our Service and hold certain information. We use Google
      Analytics (“Google, Inc.) on our Services. Google, as a third party vendor, uses cookies to
      track your behaviour anonymously on our website and app. We don’t serve ads on our website or
      app by third-parties.
    </p>

    <p>
      <strong>Third-party</strong><br />When connecting your account with Google (“Google, Inc.”) or
      Apple (Apple, Inc.”), the service will authenticate your identity and share certain
      information to us, such as your name, email address and profile picture. This information will
      be stored on our servers and added to your Account Information. We’ll only use the service to
      authenticate your account.
    </p>

    <p>
      <strong>Location Information</strong><br />We do not collect any information about the general
      location of your Internet Service Provider based on your IP Address. We also do not store any
      personal geolocation information on our servers while using location services in our website
      or app.
    </p>

    <h3 class="wp-block-heading">Information we Use</h3>

    <p>
      We may use the information we collect from you when you register, sign up for our newsletter,
      respond to a survey or marketing communication, surf the website, use our app, or use certain
      other site or app features in the following ways:
    </p>

    <ul class="wp-block-list">
      <li>
        To personalise user’s experience and to allow us to deliver the type of content and product
        offerings in which you are most interested.
      </li>

      <li>To provide and maintain the Service</li>

      <li>To notify you about changes to our Service</li>

      <li>To improve our website and app in order to better serve you.</li>

      <li>To allow us to better service you in responding to your customer service requests.</li>

      <li>To send periodic emails regarding your account or other products and services.</li>
    </ul>

    <h3 class="wp-block-heading">Information we Share</h3>

    <p>
      <strong>Third Party Disclosure</strong><br />We do not sell, trade, or otherwise transfer to
      outside parties your personally identifiable information unless we provide you with advance
      notice. This does not include website hosting partners and other parties who assist us in
      operating our website, conducting our business, or servicing you, so long as those parties
      agree to keep this information confidential. We may also release your information when we
      believe release is appropriate to comply with the law, enforce our site policies, or protect
      ours or others’ rights, property, or safety. However, non-personally identifiable visitor
      information may be provided to other parties for marketing, advertising, or other uses. It’s
      also important to note that we do not allow third party behavioural tracking.
    </p>

    <p>
      <strong>Third party links</strong><br />Occasionally, at our discretion, we may include or
      offer third party products, blogs, tickets or services on our website and app. These third
      party sites have separate and independent privacy policies. We therefore have no
      responsibility or liability for the content and activities of these linked sites. Nonetheless,
      we seek to protect the integrity of our site and welcome any feedback about these sites.
    </p>

    <p>
      <strong>Email</strong><br />We collect your email address in order to send information,
      notifications, respond to inquiries, and/or other requests or questions. You can unsubscribe
      from email communications from us by clicking on the “unsubscribe link” provided in such
      communications or turn off notifications in your account settings.
    </p>

    <p>
      <strong>Cookies</strong><br />Cookies are small files that a site or its service provider
      transfers to your computer’s hard drive through your Web browser (if you allow) that enables
      the site’s or service provider’s systems to recognise your browser and capture and remember
      certain information. For instance, we use cookies to help us remember and process the items in
      your shopping cart. They are also used to help us understand your preferences based on
      previous or current site activity, which enables us to provide you with improved services. We
      also use cookies to help us compile aggregate data about site traffic and site interaction so
      that we can offer better site experiences and tools in the future. We use cookies to
      understand and save user’s preferences for future visits. You can choose to have your computer
      warn you each time a cookie is being sent, or you can choose to turn off all cookies. You do
      this through your browser (like Internet Explorer) settings. Each browser is a little
      different, so look at your browser’s Help menu to learn the correct way to modify your
      cookies. If you disable cookies off, some features will be disabled It won’t affect the users
      experience that make your site experience more efficient and some of our services will not
      function properly.
    </p>

    <h3 class="wp-block-heading">How we Store your Information</h3>

    <p>
      <strong>Data Storage and Processing</strong><br />The information you provide is encrypted and
      stored on servers in the Netherlands. Our server is scanned on a regular basis for security
      holes and known vulnerabilities in order to make your visit to our website and app as safe as
      possible. Your personal information is contained behind secured SSL/HTTPS networks and is only
      accessible by a limited number of persons who have special access rights to such systems, and
      are required to keep the information confidential. In addition, all sensitive/credit
      information you supply is encrypted via AES-256 SSL-encryption technology. We implement a
      variety of security measures when a user submits, or accesses their information to maintain
      the safety of your personal information. Also we don't ask or store any user passwords.
    </p>

    <p>
      <strong>In-App Purchases</strong><br />All In-App Purchases are processed through the gateway
      provider (“RevenueCat, Inc.”, “Apple, Inc.”, “Google, Inc.” or “Stripe, Inc.”) and are not
      stored or processed on our servers. In order to be in line with Fair Information Practices we
      will notify the users as soon as possible via email and site/app notifications if a data
      breach occur.
    </p>

    <p>
      <strong>Image Storage</strong><br />All images you upload via our service will be stored on
      our provider in Amsterdam, The Netherlands (GDPR EU).
    </p>

    <h3 class="wp-block-heading">Accessing and Modifying your Information</h3>

    <p>
      <strong>Personal Information</strong><br />You can update your account at any time by logging
      in and changing your account settings. If you want to hide your bucket list, you can enable
      ‘Private Mode’ in your account settings at any time.
    </p>

    <p>
      <strong>Your Rights</strong><br />You have the right to access Personal Information we hold
      about you and to ask that your personal information be corrected, updated, or deleted. If you
      would like to exercise this right, please contact us through the contact information below.
    </p>

    <p>
      <strong>Data Retention</strong><br />When you create an account on our website or app, we will
      maintain your personal information for our records unless and until you ask us to delete your
      account. You can delete your account and Personal Information at any time via your account
      settings. Data that has been deleted cannot be recovered.
    </p>

    <h3 class="wp-block-heading">Contact</h3>

    <p>
      We may revise this Privacy Policy from time to time. The most current version of the policy
      will govern our use of your information and will always be at
      <a href="https://ibucket.app/privacy">https://ibucket.app/privacy</a>. If you have any
      questions about this Privacy Policy or the Service, please write to us by email at
      <a href="mailto:privacy@ibucket.app">privacy&#64;ibucket.app</a>
    </p>

    <a href="https://www.thegreenwebfoundation.org/green-web-check/?url=api.ibucket.app" target="_blank"><img
        decoding="async"
        src="https://app.greenweb.org/api/v3/greencheckimage/api.ibucket.app?nocache=true"
        alt=""
      />
      </a>
  </ion-grid>
</ion-content>
